"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/DropdownParticipantsPicker/ChipInput.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _log = require('shared/log');
var _Props = require('web/components/Form/Props');
var _EntityAvatar = require('./EntityAvatar'); var _EntityAvatar2 = _interopRequireDefault(_EntityAvatar);



/* --------------------------------
   [private] Chip Sub-Component
----------------------------------- */










const Chip = _react.forwardRef(({ entity, onClose }, ref) => {
  const myRef = _react.useRef(null)

  _react.useImperativeHandle.call(void 0, ref, () => ({
    entity,
    getBoundingClientRect: () => {
      if (myRef.current) {
        return myRef.current.getBoundingClientRect()
      }
      _log.log.error(new Error(`failed to get dimensions of rect. Ref undefined`))
      return undefined
    },
  }), [entity])

  let avatar = entity.avatar
  if (entity.type === _Props.ENTITY_TYPES.NEWUSER) {
    avatar = { userKey: entity.id }
  } else if (entity.type === _Props.ENTITY_TYPES.NEWPATIENT) {
    avatar = { patientKey: entity.id }
  }

  return (
    _react2.default.createElement('div', { className: "blmh-chip", ref: myRef, onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
      , _react2.default.createElement('div', { className: "blmh-chip--avatar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}
        , _react2.default.createElement(_EntityAvatar2.default, { avatar: avatar, size: 24, __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}})
      )
      , _react2.default.createElement('div', { className: "blmh-chip--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}, entity.title)
      , _react2.default.createElement('div', { className: "blmh-chip--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
        , _react2.default.createElement('i', { className: "material-icons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}, "close")
      )
    )
  )
})
Chip.displayName = 'Chip'

/* --------------------------------
    [public] Input Component
----------------------------------- */






















const ChipInput = _react.forwardRef(({
  inputId,
  onChange,
  value,
  placeholder,
  autoFocus,
  className,
  chips,
  onChipClose,
  onChipAdded,
  onFocus,
  onBlur,
}, ref) => {
  const [focused, setFocused] = _react.useState.call(void 0, false)
  const myRef = _react.useRef(null)
  const inputRef = _react.useRef(null)
  // Mounted chips by id; each chip's ref callback adds and removes itself.
  const chipHandles = _react.useRef({})

  _react.useImperativeHandle.call(void 0, ref, () => ({
    focus: () => inputRef.current.focus(),
    blur: () => inputRef.current.blur(),
    getBoundingClientRect: () => {
      if (myRef.current) {
        return myRef.current.getBoundingClientRect()
      }
      _log.log.error(new Error(`failed to get dimensions of rect. Ref undefined`))
      return undefined
    },
  }), [])

  // componentDidUpdate: report the newest chip once it has mounted.
  const prevChipsRef = _react.useRef.call(void 0, chips)
  _react.useLayoutEffect.call(void 0, () => {
    const prevChips = prevChipsRef.current
    prevChipsRef.current = chips
    if (chips && prevChips && chips.length > prevChips.length && onChipAdded) {
      const latestChip = chips[chips.length - 1]
      onChipAdded(chipHandles.current[latestChip.id])
    }
  })

  const setChipHandle = (chipId) => (handle) => {
    if (handle) {
      chipHandles.current[chipId] = handle
    } else {
      delete chipHandles.current[chipId]
    }
  }

  const handleChipClose = (id) => {
    if (onChipClose) {
      onChipClose(id)
    }
  }

  const handleChange = (evt) => {
    onChange(inputId, evt.target.value)
  }

  const handleKeyDown = (e) => {
    if (e.key === "Backspace" && value === "" && chips && chips.length > 0) {
      if (onChipClose) {
        const lastChip = chips[chips.length - 1]
        onChipClose(lastChip.id)
      }
    }
  }

  const handleFocus = () => {
    setFocused(true)
    if (onFocus) {
      onFocus()
    }
  }

  const handleBlur = (e) => {
    if (onBlur) {
      onBlur(e)
    }
    setFocused(false)
  }

  const hasChips = !!chips && chips.length > 0
  const inputClasses = []
  if (hasChips) {
    inputClasses.push('hide-placeholder')
  }
  if (focused) {
    inputClasses.push('blmh-input--focus')
  }
  return (
    _react2.default.createElement('div', { className: "blmh-input " + (className || ""), ref: myRef, __self: this, __source: {fileName: _jsxFileName, lineNumber: 175}}
      , _react2.default.createElement('div', { className: `blmh-input--container ${inputClasses.join(' ')}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 176}}
        , hasChips ? chips.map(c => (
          _react2.default.createElement(Chip, { ref: setChipHandle(c.id),
            key: c.id,
            entity: c,
            onClose: () => handleChipClose(c.id), __self: this, __source: {fileName: _jsxFileName, lineNumber: 178}}))) : null
        , _react2.default.createElement('input', { type: "text", className: hasChips ? 'hide-placeholder' : '',
          autoFocus: autoFocus,
          ref: inputRef,
          onFocus: handleFocus,
          onBlur: handleBlur,
          onKeyDown: handleKeyDown,
          placeholder: placeholder || '',
          onChange: handleChange,
          value: value, __self: this, __source: {fileName: _jsxFileName, lineNumber: 182}})
      )
    )
  )
})
ChipInput.displayName = 'ChipInput'

exports. default = ChipInput
